import classNames from 'helpers/class-names'
import { FC, ReactNode } from 'react'

interface Props {
  isVisible: boolean
  children: ReactNode
  className?: string
}

const ErrorMessage: FC<Props> = ({ children, isVisible, className }) => {
  return (
    isVisible && (
      <div className="overflow-hidden">
        <div
          className={classNames(
            'mt-2 flex items-start rounded-md bg-danger/20 px-4 py-2 text-sm text-danger dark:bg-danger/70 dark:text-white',
            className,
          )}>
          {children}
        </div>
      </div>
    )
  )
}

export default ErrorMessage
